import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=6da2ae59&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style1 from "./Orders.vue?vue&type=style&index=1&id=6da2ae59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2ae59",
  null
  
)

export default component.exports